module.exports = __webpack_public_path__ + "static/media/henning.692f2609.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/crew/henning.png
// module id = 609
// module chunks = 0